module.exports = __webpack_public_path__ + "static/img/Dtu1@2x.8ace18c7.png";